// Libellés partagés Marketplace (talents) — utilisés côté ESN (publication) et acheteur (recherche).

export const AVAILABILITY = [
  { v: "AVAILABLE_NOW", label: "Disponible", color: "#00E5FF" },
  { v: "AVAILABLE_SOON", label: "Bientôt disponible", color: "#F59E0B" },
  { v: "AVAILABLE_FROM_DATE", label: "Disponible à une date", color: "#F59E0B" },
  { v: "NOT_AVAILABLE", label: "En mission", color: "#8A8A93" },
];

export const REMOTE_PREFS = [
  { v: "ONSITE", label: "Sur site" },
  { v: "HYBRID", label: "Hybride" },
  { v: "REMOTE", label: "Télétravail" },
  { v: "UNKNOWN", label: "Non précisé" },
];

export const IDENTITY_MODES = [
  { v: "ANONYMOUS", label: "Anonyme (initiale)", hint: "Ex. « M. » — aucun nom visible" },
  { v: "FIRST_NAME_ONLY", label: "Prénom uniquement", hint: "Ex. « Marie »" },
  { v: "FULL_NAME", label: "Nom complet", hint: "Ex. « Marie Dupont »" },
];

export const ORG_VISIBILITY = [
  { v: "SHOW_ORGANIZATION", label: "Afficher mon organisation" },
  { v: "HIDE_UNTIL_CONTACT", label: "Masquer jusqu'au contact" },
];

export function availabilityMeta(v) {
  return AVAILABILITY.find((a) => a.v === v) || AVAILABILITY[3];
}
export function remoteLabel(v) {
  return (REMOTE_PREFS.find((r) => r.v === v) || REMOTE_PREFS[3]).label;
}

export function rateRange(min, max, currency = "EUR") {
  const c = currency === "EUR" ? "€" : currency;
  if (min && max) return `${min}–${max} ${c}/j`;
  if (min) return `dès ${min} ${c}/j`;
  if (max) return `jusqu'à ${max} ${c}/j`;
  return null;
}
